import {
	customerGlobal,
	detailCustomerGlobal,
	topFive,
	pagination,
	search,
	scrollPosition,
} from "./state"

const mutations = {
	setCustomerGlobal: (state, res) => {
		if (state.customerGlobal.data !== undefined) {
			state.customerGlobal.data = [...state.customerGlobal.data, ...res.data];
		} else {
			state.customerGlobal = res
		}
	},
	setDetailCustomerGlobal: (state, res) => {
		state.detailCustomerGlobal = res
	},
	setTopFive: (state, res) => {
		state.topFive = res
	},
	resetCustomerGlobal: (state) => {
		state.customerGlobal = customerGlobal()
	},
	resetDetailCustomerGlobal: (state) => {
		state.detailCustomerGlobal = detailCustomerGlobal()
	},
	resetTopFive: (state) => {
		state.topFive = topFive()
	},

	// pagination
	setNextPagination: (state, payload) => {
		state.pagination.length = payload.data.length
		state.pagination.pageNumber++
		state.pagination.offset = state.pagination.pageNumber * state.pagination.limit
	},
	resetPagination: (state, e) => {
		state.pagination = pagination()
	},

	// search
	setIsSearchCustomerGlobal: (state, bool) => {
		state.isSerachCustomerGlobal = bool
	},
	setSearch: (state, search) => {
		state.search.key = search;
	},
	resetSearch: (state) => {
		state.search = search();
	},

	setScrollPosition: (state, positionY) => {
		state.scrollPosition = positionY - 200
	}
}

export default mutations